<template>
  <v-app>
    <div class="image-login" id="container" style="overflow-y:hidden;">
      <v-container id="login" wrap>
        <v-layout>
          <v-flex xs12 sm7 md7 lg6 xl5 offset-xl7 offset-lg6 offset-md5 offset-sm5>
            <v-slide-x-transition>
              <v-card height="90vh" v-show="verifyLogin">
                <v-container bg fill-height grid-list-md text-xs-center>
                  <v-layout wrap align-center>
                    <v-container wrap>
                      <v-layout row>
                        <v-flex xs8 offset-xs2>
                          <v-img :src="require('@/assets/img/0_Skolable.png')"></v-img>
                        </v-flex>
                      </v-layout>
                      <v-layout row>
                        <v-flex xs8 offset-xs2>
                          <v-card-text>
                            <h2 class="text-xs-center">{{ $t('login.loginAccess') }}</h2>
                          </v-card-text>
                        </v-flex>
                      </v-layout>
                      <v-expand-transition>
                        <v-layout v-show="working.wLogin">
                          <v-flex xs12 text-xs-center>
                            <v-progress-circular indeterminate color="primary"></v-progress-circular>
                          </v-flex>
                        </v-layout>
                      </v-expand-transition>
                      <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="submit">
                        <v-container>
                          <v-layout>
                            <v-flex xs8 offset-xs2>
                              <v-text-field
                                :class="{ 'autofill-fix': autofillFix }"
                                v-model="loginForm.username"
                                :label="$t('login.username')"
                                :error-messages="usernameErrors"
                                @focus="autofillFix = false"
                              ></v-text-field>
                            </v-flex>
                          </v-layout>
                          <v-layout>
                            <v-flex xs8 offset-xs2>
                              <v-text-field
                                :class="{ 'autofill-fix': autofillFix }"
                                v-model="loginForm.password"
                                :append-icon="show ? 'visibility' : 'visibility_off'"
                                :type="show ? 'text' : 'password'"
                                :label="$t('login.password')"
                                @click:append="show = !show"
                                :error-messages="passwordErrors"
                                @focus="autofillFix = false"
                              ></v-text-field>
                            </v-flex>
                          </v-layout>
                          <v-layout wrap>
                            <v-flex xs12 text-xs-center>
                              <router-link to="recovery">{{ $t('login.forgotPassword') }}</router-link>
                            </v-flex>
                            <v-flex xs12 text-xs-center>
                              <v-btn
                                :disabled="working.wLogin || errors.eAttemptLogin"
                                class="gradiente white--text"
                                large
                                round
                                type="submit"
                              >{{ $t('login.submit') }}</v-btn>
                            </v-flex>
                          </v-layout>
                          <v-layout>
                            <v-flex xs12 text-xs-center>
                              <v-alert
                                style="border-radius: 10px;"
                                :value="errors.eLogin"
                                transition="slide-y-reverse-transition"
                                type="error"
                              >{{ errors.eMessage }}</v-alert>
                            </v-flex>
                          </v-layout>
                          <alert
                            v-model="alerts.aAttemptLogin"
                            :title="errors.eTitle"
                            :description="errors.eMessage"
                          ></alert>
                        
                        </v-container>
                      </v-form>
                    </v-container>
                  </v-layout>
                </v-container>
              </v-card>
            </v-slide-x-transition>
          </v-flex>
        </v-layout>
         
      </v-container>
      
    </div>
     
  </v-app>
</template>

<script>
import { required, email } from "vuelidate/lib/validators";
import alert from "../Dialogs/Alert";
import { mapGetters, mapActions } from "vuex";
export default {
  components: {
    alert,

  },
  validations: {
    loginForm: {
      username: { required, email },
      password: { required },
    },
  },
  data: () => ({
    confirmDisable:{
      modal: true
    },
    autofillFix: false,
    alerts: {
      aAttemptLogin: false,
    },
    errors: {
      eLogin: false,
      eAttemptLogin: false,
      eTitle: "",
      eMessage: "",
    },
    working: {
      wLogin: false,
    },
    attemps: "",
    attempDate: null,
    verifyLogin: false,
    show: false,
    valid: false,
    loginForm: {
      username: "",
      password: "",
    },
  }),
  mounted() {
    this.autoLoginCheckingInterface()

    if (this.isLoggedIn && this.isSuperAdmin) {
      this.$router.push("sa/panel/sa_home");
    }

    if (this.isLoggedIn && !this.isSuperAdmin) {
      this.$router.push("panel/home");
    }

    this.attemps = localStorage.getItem("attemps");
    if (this.$accessToken == null) {
      this.verifyLogin = true;
    }
    if (this.attemps == null) {
      this.attemps = 0;
    } else if (this.attemps >= 5) {
      this.attempDate = new Date(localStorage.getItem("attempDate"));
      if (
        Math.abs(new Date().getTime() - this.attempDate.getTime()) *
          (1 / 60000) <
        10
      ) {
        this.errors.eAttemptLogin = true;
        this.errors.eMessage = this.$t("login.errors.attemptError");
        this.errors.eTitle = "Ups";
        this.alerts.aAttemptLogin = true;
        this.errors.eLogin = true;
      } else {
        this.attempDate = null;
        this.attemps = 0;
        localStorage.removeItem("attempDate");
        localStorage.removeItem("attemps");
      }
    }
  },
  computed: {
    usernameErrors() {
      const errors = [];
      if (!this.$v.loginForm.username.$dirty) return errors;
      !this.$v.loginForm.username.email &&
        errors.push(this.$t("login.errors.eUsernameInvalid"));
      !this.$v.loginForm.username.required &&
        errors.push(this.$t("login.errors.eUsernameRequired"));
      return errors;
    },
    passwordErrors() {
      const errors = [];
      if (!this.$v.loginForm.password.$dirty) return errors;
      !this.$v.loginForm.password.required &&
        errors.push(this.$t("login.errors.ePasswordRequired"));
      return errors;
    },
    // Mappers
    ...mapGetters(["isLoggedIn", "isSuperAdmin"]),
  },
  methods: {
    ...mapActions(["getMsgDisableCollege"]),
    autoLoginCheckingInterface() {
      // each 100ms we check if the issue was produced
      let intervalDetectAutofill = setInterval(() => {
        if (
          // we target at least one of the stuff that will be affected by autofill
          // to do our checking
          document.querySelectorAll('input[type="password"]:-webkit-autofill')
            .length > 0
        ) {
          // and we inform the system about the issue if it is produced
          this.autofillFix = true

          // we stop to check if issue was produced
          clearInterval(intervalDetectAutofill)
        }
      }, 100);

      // if after 3s nothing appear, means no autofill was made
      setTimeout(() => {
        if (intervalDetectAutofill) {
          clearInterval(intervalDetectAutofill)
          intervalDetectAutofill = null
        }
      }, 3000);
    },
    submit() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.wLogin = true;
        this.processLogin();
      }
    },
    processLogin() {
      if (this.attemps < 5) {
        this.attemps++;
        localStorage.setItem("attemps", this.attemps);
        this.working.wLogin = true;

        var body = {
          client_id: process.env.VUE_APP_CLIENT_ID,
          client_secret: process.env.VUE_APP_CLIENT_SECRET,
          password: this.loginForm.password,
          grant_type: "password",
          username: this.loginForm.username,
          gadgetType: "I",
        };

        body = Object.keys(body)
          .map(function(k) {
            return encodeURIComponent(k) + "=" + encodeURIComponent(body[k]);
          })
          .join("&");

        this.$store
          .dispatch("login/login", body)
          .then(() => {

            if (this.$store.getters.isSuperAdmin) {
              localStorage.removeItem("attempDate");
              localStorage.removeItem("attemps");
              this.$router.push("sa/panel");

              // setTimeout(
              //   () => this.$store.dispatch("globalPolls/getPendpendingPolls"),
              //   500
              // );
              return
            }

            localStorage.removeItem("attempDate");
            localStorage.removeItem("attemps");
            this.$router.push("panel/home");
            // check if the user has pending polls
            setTimeout(
              () => this.$store.dispatch("globalPolls/getPendpendingPolls"),
              500
            );
          })
          .catch((error) => {
            this.processErrors(error);
          });
      } else {
        if (this.attempDate == null) {
          let date = new Date();
          localStorage.setItem("attempDate", date);
          this.attempDate = date;
          this.errors.eAttemptLogin = true;
          this.alerts.aAttemptLogin = true;
          this.errors.eMessage = this.$t("login.errors.attemptError");
          this.errors.eTitle = "Ups";
        }
      }
    },
    processErrors(error) {
      switch (error.response.status) {
        case 400:
          this.errors.eMessage = this.$t("login.errors.eUserPass");
          this.errors.eLogin = true;
          this.working.wLogin = false;
          break;
          case 503:
            this.$router.push("disable");
            this.getMsgDisableCollege(error.response.data)
            console.log(error.response.data)
            break;
         

        

      }
    },
    confirmDisble(){
      
    }
  },
};
</script>

<style scoped>
.image-login {
  background: url("../../assets/login/login_img.png") no-repeat center center;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  height: 100vh;
  margin: 0px;
}
/deep/ .autofill-fix.v-text-field .v-label {
  transform: translateY(-18px) scale(.75);
}
</style>
